import { render, staticRenderFns } from "./ModalAtendimentosDia.vue?vue&type=template&id=3f33d951&scoped=true"
import script from "./ModalAtendimentosDia.vue?vue&type=script&lang=js"
export * from "./ModalAtendimentosDia.vue?vue&type=script&lang=js"
import style0 from "./ModalAtendimentosDia.vue?vue&type=style&index=0&id=3f33d951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f33d951",
  null
  
)

export default component.exports